<template>
  <div class="color-custom-colors">
      <div class="uppercase xs-text">Create a fully custom colour scheme</div>
      <div class="uppercase xs-text mt-3 xs-content">If you would like to create a fully custom colour scheme. Simply click Configure Next and our atelier will work with you to refine the design.</div>
  </div>
</template>

<script>
import Vue from "vue";

import colorPicker from "../sub-components/color-picker.vue";

Vue.component("color-picker", colorPicker);

export default {
  name: "color-custom-colors",
  data() {
    return {
      currentSubStep: 0,
    };
  },
  components: {},
  props: ["configuratorSteps", "results", "currentStep"],
  methods: {
    goNext: function () {
      if (this.currentSubStep < this.subSteps.length - 1) {
        this.currentSubStep++;
      } else {
        this.$emit("go-next");
      }
    },
    goBack: function () {
      if (this.currentSubStep > 0) {
        this.currentSubStep--;
      } else {
        this.$emit("go-back");
      }
    },
    setPrimaryColor: function (e) {
      this.$emit("set-primary-color", e);
    },
    setSecondaryColor: function (e) {
      this.$emit("set-secondary-color", e);
    },
  },
  created() {
      this.setPrimaryColor(null);
      this.setSecondaryColor(null);
  }
};
</script>

<style lang="scss" scoped>
.color-custom-colors {
}
</style>

